import { render } from "./ValidationsEmptyState.vue?vue&type=template&id=5f8ef3b6"
import script from "./ValidationsEmptyState.vue?vue&type=script&lang=js"
export * from "./ValidationsEmptyState.vue?vue&type=script&lang=js"

import "./ValidationsEmptyState.vue?vue&type=style&index=0&id=5f8ef3b6&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__